// extracted by mini-css-extract-plugin
export var articleLink = "br11-ib";
export var articleWrap = "br11-jb";
export var avatar = "br11-ob";
export var avatarImg = "br11-pb";
export var content = "br11-kb";
export var des = "br11-lb";
export var img = "br11-rb";
export var imgWrap = "br11-qb";
export var subtitle = "br11-nb";
export var title = "br11-mb";